import {
  TicketDetailsAttributes,
  TicketPriority,
  TicketStatus,
} from "../types";

const mockUser = {
  firstName: "Bob",
  lastName: "Ross",
  fullName: "Bob Ross",
  email: "bross@twilio.com",
};

export const mockTicketDetails: TicketDetailsAttributes = {
  id: 673558,
  emailCcIds: [123456, 789012],
  requesterId: 417385879854,
  subject: `Urgent: Gotta Catch 'em All!`,
  createdAt: "2023-05-10T21:48:24Z",
  updatedAt: "2023-05-10T21:48:31Z",
  status: TicketStatus.open,
  priority: TicketPriority.p3,
  product: { name: "API", value: "product_api" },
  tags: [
    "country_set_by_ip",
    "country_us",
    "created-console",
    "flowset:agent_create",
    "language_en",
    "last-response-customer",
    "org_level_dev",
    "p3_general_issue",
    "product_api",
    "schedule_default",
    "sendgrid_support_all_options",
    "svc_support_console",
    "svc_ticket_metrics_country",
    "svc_ticket_metrics_language",
  ],
  comments: [
    {
      id: 15350277208219,
      author: {
        id: 417385879854,
        name: mockUser.fullName,
        alias: "",
        isAuthor: true,
        displayName: mockUser.fullName,
        isEndUser: false,
      },
      attachments: [
        {
          name: "Bublbasaur.png",
          url: "https://cdn.dribbble.com/users/1787323/screenshots/4458591/dribbbe_bulbasaur-01.png",
          type: "image/png",
        },
        {
          name: "Squirtle.png",
          url: "https://i.pinimg.com/736x/a1/fa/33/a1fa33101c4d121a6e643c95ee42d070.jpg",
          type: "image/png",
        },
        {
          name: "Charmander.png",
          url: "https://d1kq2dqeox7x40.cloudfront.net/images/posts/IMG_20170516_104411_WxMRnO1msS.jpg",
          type: "image/png",
        },
        {
          name: "Pikachu.png",
          url: "https://e1.pxfuel.com/desktop-wallpaper/766/1016/desktop-wallpaper-chibi-cute-pikachu-drawings-pikachu-aesthetic.jpg",
          type: "image/png",
        },
      ],
      body: "regregerg\n\n\t\r\nTicket group: --\r\nRequester email: -​ -\r\n\r\n\r\n\r\n  Join us at SIGNAL 2019, Twilio's customer and developer conference, and get 10% off your ticket with the promo code SUPPORT10.",
      htmlBody:
        '<div class="zd-comment" dir="auto"><p dir="auto">I need help with all the things!</p></div>',
      createdAt: "2023-05-10T21:48:24Z",
      public: true,
    },
    {
      id: 15350277208210,
      author: {
        id: 417385879854,
        name: "Agent Zero",
        alias: "",
        isAuthor: false,
        displayName: "Agent Zero",
        isEndUser: false,
      },
      attachments: [
        {
          name: "Agent-zero.png",
          url: "https://as2.ftcdn.net/v2/jpg/05/44/76/17/1000_F_544761783_bjxavGyfsleqqDPve3PypgczRk00ShVu.jpg",
          type: "image/png",
        },
      ],
      body: `Hi, I'm Agent Zero 👋`,
      htmlBody: `<div class="zd-comment" dir="auto"><p dir="auto">Hi, I'm Agent Zero 👋</p><p>One of our suppport agents will be here as soon as possible. In the meantime can I help you?</p></div>`,
      createdAt: "2023-05-10T21:48:24Z",
      public: true,
    },
    {
      id: 15350277208219,
      author: {
        id: 417385879854,
        name: mockUser.fullName,
        alias: "",
        isAuthor: true,
        displayName: mockUser.fullName,
        isEndUser: false,
      },
      attachments: [],
      body: "regregerg\n\n\t\r\nTicket group: --\r\nRequester email: -​ -\r\n\r\n\r\n\r\n  Join us at SIGNAL 2019, Twilio's customer and developer conference, and get 10% off your ticket with the promo code SUPPORT10.",
      htmlBody:
        '<div class="zd-comment" dir="auto"><p>Yes, please!</p><p dir="auto">How can I catch a Zapdos? ⚡️</p></div>',
      createdAt: "2023-05-10T21:49:24Z",
      public: true,
    },
    {
      id: 15350277208210,
      author: {
        id: 417385879854,
        name: "Agent Zero",
        alias: "",
        isAuthor: false,
        displayName: "Agent Zero",
        isEndUser: false,
      },
      attachments: [],
      body: "Let me think about that...",
      htmlBody: `<div class="zd-comment" dir="auto"><p dir="auto">Let me think about that...</p></div>`,
      createdAt: "2023-05-10T21:50:24Z",
      public: true,
    },
  ],
  users: [
    {
      id: 417385879854,
      name: mockUser.fullName,
      email: mockUser.email,
    },
  ],
};